import { capture, identifyUser, initPostHog, isPostHogStarted, resolveLmsBrand } from "./posthog";

function ensurePostHog() {
  if (!isPostHogStarted()) {
    initPostHog({ consentGiven: true });
  } else {
    // Keep brand in sync when path switches between Maneno and Griffle
    initPostHog({ consentGiven: true, brand: resolveLmsBrand() });
  }
}

export const LmsAnalytics = {
  init: () => initPostHog({ consentGiven: true }),
  logPageVisit: (pageName: string) => {
    ensurePostHog();
    capture("screen_view", { page: pageName });
  },
  logAction: (actionKey: string, params: Record<string, unknown> = {}) => {
    ensurePostHog();
    capture(actionKey, params);
  },
  identify: (userId: string, props?: Record<string, unknown>) => {
    ensurePostHog();
    identifyUser(userId, props);
  }
};

export { initPostHog, resolveLmsBrand };
